import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import formatFieldValue from '@UI/Pages/Subjects/Shared/Fields/formatFieldValue';
import type SubjectFieldDefinitionView from '@UI/Store/SubjectTypes/Views/SubjectFieldDefinitionView';
import type SubjectValuesView from '@UI/Store/Subjects/Views/SubjectValuesView';
import type * as React from 'react';

type Props = {
	readonly definition: SubjectFieldDefinitionView;
	readonly values: SubjectValuesView;
};

/** The value of a field of the sheet, or "Non renseigné". */
const FieldValueText: React.FC<Props> = ({ definition, values }) => {
	const text = formatFieldValue(definition, values.valueOf(definition));

	return (
		<ConditionalLoader data={text} fallback="Non renseigné">
			{(content) => content}
		</ConditionalLoader>
	);
};

export default FieldValueText;
